module.exports = __webpack_public_path__ + "static/olopade-81c74bc97ad3183da723b84e452b6151.png";